import React from 'react';
import * as styles from './index.module.scss';

import { FooterSocials } from '../footer-socials/index';
import { FooterNavLinks } from '../footer-nav-links/index';
import { Partnerships } from '../partnerships/index';
import { FooterGetInTouch } from '../footer-get-in-touch/index';

export const FooterSections = ({ data }) => {
  const { footerLinksList, partners, companyLogo, socialLinks } = data;

  return (
    <div className={styles.wrapper}>
      <FooterNavLinks data={footerLinksList} />

      <div className={styles.logoRow}>
        <FooterGetInTouch />
        <Partnerships data={partners} />
        <FooterSocials data={socialLinks} />
      </div>

      <div className={styles.bottom}>
        <p className={styles.copywrite}>
          Hamworthy Heating {new Date().getFullYear()} All Rights Reserved
        </p>
        <div className={styles.bottomRight}>
          {companyLogo?.url ? (
            <a href={companyLogo.url} className={styles.companyLogoLink}>
              <img
                alt={companyLogo?.image?.title || 'Company Logo'}
                className={styles.companyLogo}
                src={companyLogo?.image?.url}
              />
            </a>
          ) : companyLogo?.image?.url ? (
            <img
              alt={companyLogo?.image?.title || 'Company Logo'}
              className={styles.companyLogo}
              src={companyLogo?.image?.url}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
}
